import { apiRequest } from './api';

function getAuthHeaders() {
  try {
    const token = window.localStorage.getItem('chse_auth_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  } catch {
    return {};
  }
}

export async function getHomeDashboard() {
  return apiRequest('/api/dashboard/home', {
    method: 'GET',
    headers: getAuthHeaders(),
  });
}
